$(document).foundation();

jQuery(document).ready(function($) {

	var header = document.querySelector("header");
	
	var offsetHeader = 200;
	if (Foundation.MediaQuery.only('small')) { 
		offsetHeader = 150;
	}
	
	var options = {
		offset: offsetHeader,
	};
	var headroom  = new Headroom(header, options);

	mainHandler.init();
	headroom.init().then(
		animateHandler.init()
	);

	// refresh scrolltrigger when image is done loading and when all are done loading
	$('body img:not(.ignore-load)').imagesLoaded()
	.done( function( instance ) {
		ScrollTrigger.refresh(true)
	})
	.progress( function( instance, image ) {
		ScrollTrigger.refresh(true)
	})

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		$(this).parent().addClass('responsive-embed widescreen')
	})

	// debugger
	$(window).on('resize', function() {
		$('.debugger .column-width').html($('.debugger .cell').eq(0).width())
		$('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
		$('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
	}).trigger('resize')

	$('.debugger').on('click', function(e) {
		$(this).remove()
	})
	

})
